document.addEventListener('DOMContentLoaded', function() {
    if (!window.debugVimeoURLs || !Array.isArray(window.debugVimeoURLs)) {
      return;
    }

    const wrappers = Array.from(document.querySelectorAll('.vimeo-thumb-wrapper'));
    let activePlayer = null;
    
    wrappers.forEach(function(wrapper, index) {
      const videoId = wrapper.dataset.videoId;
      const videoUrl = `https://player.vimeo.com/video/${videoId}?autopause=1&dnt=1&portrait=0&title=0&byline=0&controls=1`;
      
      // Add loading state
      wrapper.innerHTML = `
        <div class="loading-state" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f5f5f5;">
          <div class="loading-spinner"></div>
        </div>
      `;
      
      // Try to fetch thumbnail from Vimeo API
      fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Vimeo API request failed');
          }
          return response.json();
        })
        .then(data => {
          if (!data || !data[0] || !data[0].thumbnail_large) {
            throw new Error('Invalid thumbnail data');
          }
          
          const thumbnailUrl = data[0].thumbnail_large.replace('_640', '_1080x1920');
          updateThumbnail(wrapper, videoUrl, thumbnailUrl, index);
        })
        .catch(error => {
          console.warn(`Failed to load thumbnail for video ${videoId}:`, error);
          
          // Try fallback thumbnail URL
          const fallbackUrl = `https://i.vimeocdn.com/video/${videoId}_1080x1920.jpg`;
          updateThumbnail(wrapper, videoUrl, fallbackUrl, index);
        });
    });

    function updateThumbnail(wrapper, videoUrl, thumbnailUrl, index) {
      const img = new Image();
      
      img.onload = function() {
        wrapper.innerHTML = `
          <a href="${videoUrl}"
             data-fancybox="video-gallery"
             data-type="iframe"
             style="display: block; width: 100%; height: 100%; position: relative;">
            <img src="${thumbnailUrl}"
                 alt="Video ${index + 1}"
                 style="width: 100%; 
                        height: 100%; 
                        object-fit: cover;
                        display: block;">
            <div class="play-button-overlay">
              <svg width="80" height="80" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </a>
        `;
      };
      
      img.onerror = function() {
        // If both API and fallback fail, show error state
        wrapper.innerHTML = `
          <div class="error-state" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f5f5f5; color: #666;">
            <span>Video thumbnail unavailable</span>
          </div>
        `;
      };
      
      img.src = thumbnailUrl;
    }

    Fancybox.bind('[data-fancybox="video-gallery"]', {
      groupAll: true,
      dragToClose: false,
      Toolbar: {
        display: [
          "close",
        ],
      },
      Html: {
        video: {
          autoplay: false
        }
      },
      Iframe: {
        preload: false,
        css: {
          width: '100%',
          height: '100%'
        },
        attributes: {
          allow: "fullscreen"
        }
      },
      on: {
        "Carousel.change": (fancybox, carousel, slide) => {
          const iframes = document.querySelectorAll('.fancybox__container iframe');
          iframes.forEach(iframe => {
            try {
              const player = new Vimeo.Player(iframe);
              player.pause();
            } catch (err) {}
          });
        },
        
        "done": (fancybox, slide) => {
          const iframe = slide.$el.querySelector('iframe');
          if (iframe) {
            activePlayer = new Vimeo.Player(iframe);
          }
        },
        
        "destroy": (fancybox) => {
          if (activePlayer) {
            activePlayer.pause();
            activePlayer = null;
          }
        }
      }
    });

    // Add custom styles for Fancybox
    const style = document.createElement('style');
    style.textContent = `
      /* Make videos larger in fancybox */
      .fancybox__container .fancybox__content {
        width: 90vw !important;
        height: 90vh !important;
        max-width: 1200px !important;
        margin: 0 auto !important;
      }
      
      /* Hide thumbnails in fancybox */
      .fancybox__container .carousel__nav, 
      .fancybox__container .fancybox__thumbs {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
});